function klaviyoTrackViewedPage(config) {
  if (!config) return;
  window.klaviyo?.push([
    'track',
    'Viewed Page',
    {
      page_url: config.page_url,
      page_title: config.page_title,
      page_tags: config.page_tags,
    },
  ]);
}

function klaviyoTrackHighIntent(eventName, idKey, id, data) {
  const storageKey = `viewed${idKey}_${id}`;
  const viewCount = parseInt(localStorage.getItem(storageKey) || '0') + 1;
  localStorage.setItem(storageKey, viewCount);

  window.klaviyo?.push([
    'track',
    eventName,
    {
      ...data,
      ViewCount: viewCount,
    },
  ]);
}

async function structureItem(item) {
  const {
    tags,
    productid,
    index,
    baseprice,
    price,
    categories,
    variantname,
    featuredimage,
    variant_tags,
    is_bundle,
    ...rest
  } = item;
  let intPrice = parseInt(item.price);
  const intBase = parseInt(baseprice);
  let formattedPrice = intPrice / 100;
  const intCompare = parseInt(item.compare_at_price);
  const uvpDiff = intCompare && intCompare > intPrice ? intCompare - intPrice : 0;
  const onSale = intCompare > intPrice;
  const extraDiscount = await co2.itemDiscountFull(
    parseInt(productid),
    parseInt(item.item_variant_id),
    tags,
    intBase,
    item.quantity,
    variant_tags || [],
    onSale
  );

  const discPrice = extraDiscount ? extraDiscount.discPrice / 100 : undefined;
  const discDif = intPrice === 0 ? intBase / 100 : Math.round((intBase / 100 - discPrice) * 100) / 100;
  let availability = item.item_status;

  if (is_bundle) {
    const bundleInfo = await co2.bundleDataForCollectionProduct(productid);
    availability = bundleInfo?.available ? 'available' : 'out_of_stock';
    // cart view event
    formattedPrice = item.baseprice / 100;
  }

  return {
    ...rest,
    discount: discDif ? uvpDiff + discDif : 0,
    coupon: await co2.getDiscountCode(),
    price: discPrice < formattedPrice && !is_bundle ? discPrice : formattedPrice,
    item_status: availability,
  };
}

// --- Helper: einzelne Cart-Line zu GA4-Line-Item transformieren
async function cartItemToDataLayerItem(cartItem, quantity) {
  const delivery_period =
    document.getElementById('localization-delivery-time')?.textContent || '';
  const qty = quantity ?? cartItem.quantity ?? 1;
  const original_price_cents = cartItem.price;
  const final_price_cents    = cartItem.final_price;

  const discount = ((original_price_cents - final_price_cents) * qty) / 100;

  const coupon = await co2.getDiscountCode();
  const value  = (final_price_cents * qty) / 100;

  return {
    item_name: cartItem.product_title,
    item_id: cartItem.sku,
    discount,
    coupon,
    currency: Shopify.currency.active,
    item_brand: cartItem.vendor,
    item_variant: cartItem.variant_title,
    item_variant_id: cartItem.variant_id?.toString(),
    item_type: cartItem.product_type,
    item_status: 'available',
    item_delivery_period: delivery_period,
    quantity: qty,
    price: value,
    value,
  };
}

// --- Helper: einzelne Cart-Line zu Klaviyo-"Added to Cart"-Payload
function cartItemToKlaviyoItem(cartItem, quantity) {
  const qty = quantity ?? cartItem.quantity ?? 1;
  const final_price_cents = cartItem.final_price;
  const value = (final_price_cents * qty) / 100;

  return {
    price: value,
    quantity: qty,
    item_variant_id: cartItem.variant_id,
    product_id: cartItem.product_id,
    variant_sku: cartItem.sku,
    product_name: cartItem.product_title,
    variant_name: cartItem.variant_title,
    brand: cartItem.vendor,
    url: window.location.href,
    image_url: cartItem.featured_image?.url || cartItem.image,
    currency: Shopify.currency.active,
    locale: `${Shopify.locale}-${Shopify.country}`,
    value,
  };
}

let trackedOnce = false;
document.addEventListener('DOMContentLoaded', async () => {
  if (window.klaviyoPageData) {
    klaviyoTrackViewedPage(window.klaviyoPageData);
  }

  if (window.klaviyoHighIntentData) {
    const { eventName, idKey, id, data } = window.klaviyoHighIntentData;
    setTimeout(function () {
      klaviyoTrackHighIntent(eventName, idKey, id, data);
    }, 30000);
  }

  const cartDrawer = document.getElementsByClassName('drawer')[0];
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        publish('cartOpen');
      }
    });
  });
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true });
  }

  window.dataLayer = window.dataLayer || [];

  // --- 1. page_meta ---
  const pageMetaScript = document.getElementById('page-meta-datalayer');
  if (pageMetaScript) {
    const meta = JSON.parse(pageMetaScript.textContent);
    meta.referral_url = document.referrer;
    window.dataLayer.push({
      event: 'page_meta',
      website_country: meta.website_country,
      website_language: meta.website_language,
      environment: meta.environment,
      page_type: meta.page_type,
      referral_url: meta.referral_url,
      traffic_type: meta.traffic_type,
      login_status: meta.login_status,
      user_id: meta.user_id,
      customer_type: meta.customer_type,
    });
  }

  // --- 2. view_item ---
  const productItemScript = document.querySelector('.product-item-datalayer');
  let productItem = {};
  if (productItemScript) {
    productItem = JSON.parse(productItemScript.textContent);
  }
  subscribe('price-calculated', async ({ price, discount, id, variantId }) => {
    const currentVariantId = parseInt(productItem.item_variant_id, 10);
    const currentProductId = parseInt(productItem.productid, 10);

    if (productItemScript && !trackedOnce && id === currentProductId && variantId === currentVariantId) {
      trackedOnce = true;
      const item = JSON.parse(productItemScript.textContent);
      const structuredItem = await structureItem(item);

      setTimeout(function () {
        const storageKey = `viewedProduct_${item.productid}`;
        const viewCount = parseInt(localStorage.getItem(storageKey) || '0') + 1;
        localStorage.setItem(storageKey, viewCount);

        window.klaviyo?.push([
          'track',
          'High Intent - Viewed Product',
          {
            ViewCount: viewCount,
            Price: price,
            Categories: item.categories,
            Brand: item.item_brand,
            ImageURL: item.featuredimage,
            CompareAtPrice: item.compare_at_price,
            URL: window.location.href,
            ProductID: item.productid,
            Name: item.item_name,
          },
        ]);
      }, 30000);

      window.dataLayer.push({
        event: 'Ecommerce - view_item',
        event_name: 'view_item',
        ecommerce: {
          currency: structuredItem.currency,
          value: price,
          items: [{ ...structuredItem, price: price, discount }],
        },
      });
    }
  });

  // --- 3. view_item_list ---
  const productListScripts = document.querySelector('.product-list-item-datalayer');
  if (productListScripts) {
    const items = [];
    let content = JSON.parse(productListScripts.textContent);

    for (const script of content.items) {
      const item = await structureItem(script);
      items.push(item);
    }
    window.dataLayer.push({
      event: 'Ecommerce - view_item_list',
      event_name: 'view_item_list',
      ecommerce: {
        item_list_name: content.name,
        item_list_id: content.id,
        items,
      },
    });
  }

  // --- 4. view_cart ---
  subscribe('cartOpen', async () => {
    const cartItemScripts = document.querySelectorAll('.cart-item-datalayer');
    if (cartItemScripts.length) {
      const items = [];
      let totalValue = 0;
      for (const script of cartItemScripts) {
        let item = JSON.parse(script.textContent);
        item = await structureItem(item);
        totalValue += item.price;
        items.push(item);
      }
      window.dataLayer.push({
        event: 'Ecommerce - view_cart',
        event_name: 'view_cart',
        ecommerce: {
          value: totalValue,
          currency: items.length > 0 ? items[0].currency : 'EUR',
          coupon: items.length > 0 ? items.find((item) => item.coupon)?.coupon || '' : '',
          gift_card_value: 0,
          items,
        },
      });
    }
  });

  // --- 5. add_to_cart ---
  async function handleAddToCartTracking(e) {
    try {
      if (!window.MNRCartLines?.getAddedLinesFromPayload) {
        console.error('[tracking] window.MNRCartLines fehlt — add_to_cart wird nicht getrackt (cart-added-lines.js nicht geladen?).');
        return;
      }

      const addedLines = window.MNRCartLines.getAddedLinesFromPayload(e);
      if (!addedLines.length) return;

      const origin = 'product';

      let method = 'unknown';
      if (e.source === 'manual-add') {
        method = 'manual_free_gift';
      } else if (e.source === 'auto-add') {
        method = 'auto_free_gift';
      } else if (e.submitter?.dataset?.method) {
        method = e.submitter.dataset.method;
      }

      const items = [];
      let totalValue = 0;

      for (const { cartItem, quantity } of addedLines) {
        // GA4-Line-Item
        const line = await cartItemToDataLayerItem(cartItem, quantity);
        items.push(line);
        totalValue += line.value || 0;

        // Klaviyo-Pro-Item-Event
        const klaviyoPayload = cartItemToKlaviyoItem(cartItem, quantity);
        window.klaviyo?.push(['track', 'Added to Cart', klaviyoPayload]);
      }

      window.dataLayer.push({
        event: 'Ecommerce - add_to_cart',
        event_name: 'add_to_cart',
        ecommerce: {
          value: totalValue,
          currency: Shopify.currency?.active || 'EUR',
          origin,
          method,
          items,
        },
      });
    } catch (error) {
      console.error('Error in add_to_cart tracking:', error, e);
    }
  }

  // "normale" Events (Product Form, Gifts, etc.)
  subscribe(PUB_SUB_EVENTS.addToCartSuccess, handleAddToCartTracking);

  // "stille" Events, die trotzdem getrackt werden sollen
  subscribe(PUB_SUB_EVENTS.addToCartSuccessSilent, handleAddToCartTracking);


  // --- 6. remove_from_cart ---
  subscribe('removeFromCartSuccess', async (e) => {
    const item = await structureItem(e.removedItem);
    window.dataLayer.push({
      event: 'Ecommerce - remove_from_cart',
      event_name: 'remove_from_cart',
      ecommerce: {
        currency: item.currency,
        value: item.price,
        origin: 'product',
        method: e.method ?? 'manual',
        items: [item],
      },
    });
  });

  // --- 7. search ---
  subscribe('predictiveSearch', (e) => {
    const { searchTerm, type, results } = e;
    window.dataLayer.push({
      event: 'custom_event',
      event_name: 'search',
      search: {
        search_term: searchTerm,
        search_type: type,
        search_results: results,
      },
    });
  });

  // Manual search
  if (window.location.pathname.includes('/search')) {
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q');
    const resultsCount = document.querySelectorAll('.product-grid .grid__item').length;
    window.dataLayer.push({
      event: 'custom_event',
      event_name: 'search',
      search: {
        search_term: searchTerm,
        search_type: 'free_form',
        search_results: resultsCount,
      },
    });
  }

  // --- 8. view_promotion ---
  const promoScript = document.querySelector('.promotion-datalayer');
  if (promoScript) {
    const promo = JSON.parse(promoScript.textContent);
    const item = await structureItem(promo.items[0]);
    window.dataLayer.push({
      event: 'Ecommerce - view_promotion',
      event_name: 'view_promotion',
      ecommerce: {
        creative_name: promo.creative_name,
        creative_slot: 'home_page_banner',
        promotion_id: promo.promotion_id,
        promotion_name: promo.promotion_name,
        items: [item],
      },
    });
  }

  // --- 9. select_promotion ---
  const homebanners = document.querySelectorAll('[data-home-banner-link]');
  homebanners.forEach((homebanner) => {
    if (homebanner) {
      homebanner.addEventListener('click', async (event) => {
        event.preventDefault();

        if (promoScript) {
          const promo = JSON.parse(promoScript.textContent);
          const item = await structureItem(promo.items[0]);
          window.dataLayer.push({
            event: 'Ecommerce - select_promotion',
            event_name: 'select_promotion',
            ecommerce: {
              creative_name: promo.creative_name,
              creative_slot: 'home_page_banner',
              promotion_id: promo.promotion_id,
              promotion_name: promo.promotion_name,
              items: [item],
            },
          });

          const target = homebanner.getAttribute('data-target');
          if (target) {
            window.location.href = target;
          }
          homebanner.setAttribute('role', 'link');
          homebanner.setAttribute('tabindex', '0');
          homebanner.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              if (target) {
                window.location.href = target;
              }
            }
          });
        }
      });
    }
  })

  // --- 10. change_item_variant ---
  subscribe(PUB_SUB_EVENTS.variantChange, async () => {
    const itemScript = document.querySelector('.product-item-datalayer');
    if (itemScript) {
      let item = JSON.parse(itemScript.textContent);
      item = await structureItem(item);

      window.dataLayer.push({
        event: 'custom_event',
        event_name: 'change_item_variant',
        ecommerce: {
          currency: item.currency,
          value: item.price,
          items: [item],
        },
      });
    }
  });

  // --- 11. navigation_sidebar ---
  document
    .querySelectorAll('header .list-menu__item, .mega-menu__link, .menu-drawer__link-group__link')
    .forEach((el) => {
      el.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'custom_event',
          event_name: 'navigation_sidebar',
          navigation_sidebar: { click_item: el.innerText },
        });
      });
    });

  // --- 12. select_item on collection page ---
  document.querySelectorAll('.card__heading a').forEach((el) => {
    if (!el.closest('tile-slider')) {
      el.addEventListener('click', async () => {
        const content = el.closest('.card-wrapper').querySelector('.productlist-item-datalayer').textContent;

        if (!content || !productListScripts) return;

        let collectionContent = JSON.parse(productListScripts.textContent);
        const item = JSON.parse(content);
        const structuredItem = await structureItem(item);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Ecommerce - select_item',
          event_name: 'select_item',
          ecommerce: {
            item_list_name: collectionContent.name,
            item_list_id: collectionContent.id,
            items: [{ index: item.index, ...structuredItem }],
          },
        });
      });
    }
  });

  // --- 13. modal_open (Quick Add To Cart Modal) ---
  subscribe(PUB_SUB_EVENTS.openQuickAdd, async (event) => {
    if (event.source === 'quick-add') {
      let item;
      const content = event.modalContent?.querySelector('.product-item-datalayer')?.textContent;
      if (content) {
        item = JSON.parse(content);
        const structuredItem = await structureItem(item);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Ecommerce - modal_open',
          event_name: 'modal_open',
          modal: 'quick_add_to_cart',
          ecommerce: {
            currency: structuredItem.currency,
            value: structuredItem.price,
            items: [{ ...structuredItem, value: structuredItem.price }],
          },
        });
      }
    }
  });

  // --- 13. modal_close (Quick Add To Cart Modal) ---
  subscribe(PUB_SUB_EVENTS.closeQuickAdd, async (event) => {
    if (event.source === 'quick-add') {
      let item;
      const content = event.modalContent?.querySelector('.product-item-datalayer')?.textContent;
      if (content) {
        item = JSON.parse(content);
        const structuredItem = await structureItem(item);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Ecommerce - modal_close',
          event_name: 'modal_close',
          modal: 'quick_add_to_cart',
          ecommerce: {
            currency: structuredItem.currency,
            value: structuredItem.price,
            items: [{ ...structuredItem, value: structuredItem.price }],
          },
        });
      }
    }
  });

});
